import { languageScriptMap } from '@/components/LanguageSelect';
import { SupportedLanguage } from '@/utils/types';

export const validateInputLanguage = (value: string, language: SupportedLanguage = 'english') => {
    const languageScript = languageScriptMap[language];
    const regex = new RegExp(`^[\\p{Script=${languageScript}}\\s]*$`, 'u');
    return regex.test(value);
};
